import { cloneElement } from "react";
import {
  CreateButton,
  Filter,
  NumberInput,
  TextInput,
  TopToolbar,
  useListContext,
} from "react-admin";
import Button from "@mui/material/Button";
import VerticalAlignCenterIcon from "@mui/icons-material/VerticalAlignCenter";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";

import {
  TOPIC_ORDERABLE_LABEL,
  TOPIC_LIST_LABEL,
} from "../../constants/titleConstants";

const TopicFilter = props => (
  <Filter {...props}>
    <NumberInput label="ID" source="id" />
    <TextInput label="Name" source="name_i18n" />
  </Filter>
);

const TopicListButton = ({ topicOrderableHandle, isShowingTopicOrderable }) => (
  <Button onClick={topicOrderableHandle} size="small">
    {isShowingTopicOrderable ? (
      <FormatAlignJustifyIcon />
    ) : (
      <VerticalAlignCenterIcon />
    )}
    {isShowingTopicOrderable ? TOPIC_LIST_LABEL : TOPIC_ORDERABLE_LABEL}
  </Button>
);

const TopicActions = props => {
  const { className, filters, topicOrderableHandle, isShowingTopicOrderable } =
    props;
  const { resource, displayedFilters, filterValues, showFilter } =
    useListContext();
  return (
    <TopToolbar className={className}>
      {isShowingTopicOrderable || (
        <>
          {cloneElement(filters, {
            resource,
            showFilter,
            displayedFilters,
            filterValues,
            context: "button",
          })}
          <CreateButton />
        </>
      )}
      <TopicListButton
        topicOrderableHandle={topicOrderableHandle}
        isShowingTopicOrderable={isShowingTopicOrderable}
      />
    </TopToolbar>
  );
};

export { TopicActions, TopicFilter };
